// Importação das funções principais do Redux
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';

// Importação do middleware redux-thunk para lidar com ações assíncronas
import thunk from 'redux-thunk';

// Importação do reducer responsável pela autenticação do usuário
import { AuthReducer } from './reducers/AuthReducer';

// Aplica o middleware redux-thunk ao Redux Store
const middleware = applyMiddleware(thunk);

// Configuração do Redux DevTools (se estiver disponível no navegador)
const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Combina todos os reducers da aplicação (neste caso, apenas o de autenticação)
const reducers = combineReducers({
    auth: AuthReducer  // O estado 'auth' será gerenciado pelo AuthReducer
});

// Criação do Redux Store com os reducers e middlewares aplicados
export const store = createStore(reducers, composeEnhancers(middleware));
